var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodataCuate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 586.427,
    height: 384.25,
    viewBox: "0 0 586.427 384.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_data-cuate",
    "data-name": "No data-cuate",
    transform: "translate(-65.62 -55.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-38",
    transform: "translate(65.62 55.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8355",
    "data-name": "Path 8355",
    d: "M661.955,148.2l-9.171,44.416-5.9-5.759-10.043,7.168-7.676-9.535L611.952,197l-14.71-24.6-16.406,9.612-6.507-8.969L553.5,184.786,547.23,171.36l14.6-70.73L640.125,116.8Z",
    transform: "translate(-85.715 -57.603)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8356",
    "data-name": "Path 8356",
    d: "M643.938,117.5l21.83,31.4L638.61,143.3Z",
    transform: "translate(-89.527 -58.307)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8357",
    "data-name": "Path 8357",
    d: "M650.163,204.955l-13.445,65.163L531.26,248.346l13.349-64.636,6.267,13.416,20.843-11.739,6.5,8.969,16.415-9.6,14.7,24.6,17.22-12.515,7.666,9.525,10.052-7.158Z",
    transform: "translate(-85.048 -61.07)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8358",
    "data-name": "Path 8358",
    d: "M492.779,191.978l-107.471,6.65L376.77,60.675l79.805-4.945L485.87,80.31Z",
    transform: "translate(-78.602 -55.73)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8359",
    "data-name": "Path 8359",
    d: "M460.05,55.73l29.294,24.58-27.675,1.715Z",
    transform: "translate(-82.077 -55.73)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8360",
    "data-name": "Path 8360",
    d: "M428.4,150l-.422-3.114c-1.083-6.449.68-13.665,6.286-21.207,5.06-6.708,7.8-11.5,7.494-16.942-.345-6.133-4.418-10-12-9.7a21.379,21.379,0,0,0-11.931,4.408l-3.306-7.407c3.833-3.114,10.541-5.414,16.914-5.75,13.828-.767,20.555,7.417,21.082,16.549.46,8.174-3.776,14.317-9.161,21.494-4.945,6.545-6.564,11.94-5.865,18.044l.3,3.124Zm-1.706,16.971c-.249-4.446,2.578-7.743,6.785-7.973s7.273,2.721,7.522,7.177c.23,4.207-2.348,7.6-6.794,7.848-4.245.24-7.312-2.846-7.551-7.053Z",
    transform: "translate(-80.178 -57.17)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8361",
    "data-name": "Path 8361",
    d: "M146.937,127.9,136.128,123l-1.5,3.306a2.875,2.875,0,0,1-2.463,1.648,13.875,13.875,0,0,0-1.773.172A2.875,2.875,0,0,1,127.657,127l-2.118-2.961-9.65,6.919,2.118,2.961a2.875,2.875,0,0,1,.192,2.942,17.527,17.527,0,0,0-.738,1.619,2.875,2.875,0,0,1-2.348,1.811l-3.613.355,1.16,11.816,3.632-.364a2.875,2.875,0,0,1,2.654,1.322c.153.249.316.489.489.728s.345.47.527.7a2.817,2.817,0,0,1,.4,2.923L118.85,161.1l10.819,4.906,1.5-3.325a2.875,2.875,0,0,1,2.472-1.639,15.513,15.513,0,0,0,1.754-.172A2.875,2.875,0,0,1,138.13,162l2.118,2.961,9.659-6.919-2.118-2.961a2.789,2.789,0,0,1-.192-2.942,17.192,17.192,0,0,0,.719-1.61,2.817,2.817,0,0,1,2.348-1.811l3.632-.364-1.169-11.816-3.632.355a2.817,2.817,0,0,1-2.635-1.313c-.163-.249-.326-.489-.5-.728s-.345-.479-.527-.7a2.875,2.875,0,0,1-.4-2.942ZM140.8,138.831a9.726,9.726,0,1,1-13.569-2.242,9.726,9.726,0,0,1,13.569,2.242Z",
    transform: "translate(-67.534 -58.537)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8362",
    "data-name": "Path 8362",
    d: "M657.905,291.71l-7.206,4.159,1.275,2.2a1.916,1.916,0,0,1-.067,2.079c-.22.345-.431.7-.623,1.073a1.917,1.917,0,0,1-1.754,1.092H647v8.327h2.549a1.917,1.917,0,0,1,1.754,1.092c.192.374.4.728.623,1.073a1.917,1.917,0,0,1,.067,2.08l-1.275,2.2,7.206,4.159,1.284-2.214a1.965,1.965,0,0,1,1.83-.958h1.227a1.974,1.974,0,0,1,1.83.958l1.284,2.223,7.2-4.159-1.275-2.214a1.965,1.965,0,0,1,.077-2.07c.22-.345.431-.709.623-1.073a1.916,1.916,0,0,1,1.754-1.092H676.3v-8.327h-2.568a1.916,1.916,0,0,1-1.754-1.092c-.192-.364-.4-.728-.623-1.073a1.965,1.965,0,0,1-.077-2.07l1.275-2.214-7.2-4.159-1.284,2.185a1.964,1.964,0,0,1-1.83.958H661.02a1.993,1.993,0,0,1-1.84-.958Zm3.728,7.954a2.831,2.831,0,1,1,0-.01Z",
    transform: "translate(-89.878 -65.576)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8363",
    "data-name": "Path 8363",
    d: "M170.887,91.12l-6.6,5.06,1.524,2.022a1.916,1.916,0,0,1,.2,2.06,10.033,10.033,0,0,0-.479,1.15,1.964,1.964,0,0,1-1.6,1.313l-2.53.326,1.073,8.251,2.53-.326a1.974,1.974,0,0,1,1.917.862,10.682,10.682,0,0,0,.747.958,1.917,1.917,0,0,1,.345,2.041l-.958,2.357,7.666,3.191.958-2.357a1.965,1.965,0,0,1,1.7-1.2l.613-.067.6-.1a1.974,1.974,0,0,1,1.917.719l1.562,2.041,6.6-5.06-1.543-2.022a1.974,1.974,0,0,1-.2-2.07,10.651,10.651,0,0,0,.479-1.14,1.964,1.964,0,0,1,1.6-1.313l2.53-.326-1.073-8.251-2.53.326a1.974,1.974,0,0,1-1.917-.853,8.544,8.544,0,0,0-.757-.958,1.984,1.984,0,0,1-.288-2l.958-2.357-7.666-3.191-.958,2.357a1.984,1.984,0,0,1-1.7,1.2l-.613.057-.565.019a1.974,1.974,0,0,1-1.917-.719Zm4.724,7.407a6.813,6.813,0,1,1-4.536,2.609,6.813,6.813,0,0,1,4.536-2.609Z",
    transform: "translate(-69.616 -57.169)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8364",
    "data-name": "Path 8364",
    d: "M119.029,311.739a264.131,264.131,0,0,0-.383-27.79,355.316,355.316,0,0,0-8.711-56.692c-2.434-10.484-5.424-20.795-8.548-31.1-.1-.316-.594-.23-.508.1,9.65,36.319,17.565,73.787,17.019,111.543-.153,10.541-1.38,20.938-2.377,31.441,0,.278.431.393.5.105C118,330.33,118.656,320.919,119.029,311.739Z",
    transform: "translate(-67.091 -61.581)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8365",
    "data-name": "Path 8365",
    d: "M100.366,196.24s-14.6,37.085-11.336,45.767,10.014,10.541,10.014,10.541S90.1,265.313,96.35,277.281s20.124,11.4,21.082,24.973C117.4,302.321,118.17,245.582,100.366,196.24Z",
    transform: "translate(-66.577 -61.593)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8366",
    "data-name": "Path 8366",
    d: "M116.237,279.232a.268.268,0,0,0,0-.192,339.527,339.527,0,0,0-14.163-74.6c0-.067-.144-.048-.125,0q4.341,16.291,7.666,32.716a16.166,16.166,0,0,0-6.976-3.891s-.077.057,0,.077a18.543,18.543,0,0,1,7.206,4.791c.422,2.156.843,4.3,1.236,6.459-3.268-3.651-7.791-5.462-12.323-7.187a.058.058,0,0,0,0,.105c4.724,1.917,9.42,4.389,12.62,8.462q1.667,9.228,2.932,18.523A17.661,17.661,0,0,0,105.6,259.5c-.105,0-.163.125-.058.153a18.36,18.36,0,0,1,8.778,5.692h.058q.431,3.258.824,6.545a22.394,22.394,0,0,0-6.1-3.68c-.057,0-.1.067,0,.086a20.976,20.976,0,0,1,6.123,4.053h.077c.24,2.079.479,4.159.69,6.238a29.707,29.707,0,0,0-12.391-8.854.077.077,0,1,0,0,.153,32.274,32.274,0,0,1,12.208,9.4.287.287,0,0,0,.307.1c.316,3.191.6,6.382.834,9.583a.038.038,0,0,0,.077,0Q116.65,284.147,116.237,279.232Z",
    transform: "translate(-67.001 -61.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8367",
    "data-name": "Path 8367",
    d: "M104.365,230.591a18.294,18.294,0,0,0-8.778-2.741.057.057,0,0,0,0,.115,34.651,34.651,0,0,1,8.682,2.875C104.384,230.869,104.471,230.667,104.365,230.591Z",
    transform: "translate(-66.868 -62.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8368",
    "data-name": "Path 8368",
    d: "M106.31,271.582a18.265,18.265,0,0,0-6.593-2.252c-.077,0-.086.105,0,.125a24.962,24.962,0,0,1,6.516,2.281C106.32,271.783,106.4,271.63,106.31,271.582Z",
    transform: "translate(-67.04 -64.642)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8369",
    "data-name": "Path 8369",
    d: "M158.262,244.667a99.375,99.375,0,0,0-16.914,14.777,60.554,60.554,0,0,0-11.854,20.124,150.383,150.383,0,0,0-8.835,48.105,117.218,117.218,0,0,0,2.6,27.052.259.259,0,0,0,.508-.1,151.982,151.982,0,0,1,.268-47.291c2.511-15.332,6.449-32.026,16.2-44.493,5.309-6.794,11.931-12.132,18.476-17.651C159.057,244.887,158.616,244.418,158.262,244.667Z",
    transform: "translate(-67.915 -63.61)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8370",
    "data-name": "Path 8370",
    d: "M122.9,316.583a91.037,91.037,0,0,1,12.323-15.754c7.312-7.312,13.464-12.506,14.422-17.335s-7.321-8.395-7.321-8.395,10.11,1.821,12.879-2.424,4.1-28.835,4.1-28.835-18.4,13.138-26.975,31.556S122.9,316.583,122.9,316.583Z",
    transform: "translate(-68.01 -63.579)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8371",
    "data-name": "Path 8371",
    d: "M152.939,250.416c-7.743,7.6-15.534,15.706-20.124,25.7a98.537,98.537,0,0,0-4.073,10.589h0c-.23.728-.47,1.457-.69,2.185a.182.182,0,0,0,0,.115,209.17,209.17,0,0,0-5.232,22.721c0,.048.067.067.077,0,.8-3.833,1.667-7.666,2.645-11.566a.258.258,0,0,0,.115,0,16.424,16.424,0,0,1,4.791-1.227c.105,0,.1-.2,0-.192a17.991,17.991,0,0,0-4.791.872c.891-3.479,1.859-6.957,2.951-10.378a51.1,51.1,0,0,1,10.915-1.428v-.057a41.2,41.2,0,0,0-10.733.91c.192-.585.393-1.169.585-1.754a56.651,56.651,0,0,1,7.264-1.236s0-.077,0-.077a35.459,35.459,0,0,0-7.11.862c.958-2.961,2.079-5.884,3.277-8.72a52.7,52.7,0,0,1,3.479-6.708,43.627,43.627,0,0,1,5.893-1.054v-.1a15.973,15.973,0,0,0-5.51.546c.958-1.562,1.984-3.1,3.076-4.581h0c4.13-.91,8.308-1.763,12.534-.958a.067.067,0,0,0,0-.125c-4.015-1.064-8-.45-12,.335.431-.575.882-1.15,1.332-1.715a27.244,27.244,0,0,1,7.666-1.217v-.086a20.209,20.209,0,0,0-7.187.642c3.411-4.236,7.178-8.222,10.905-12.16C153.255,250.339,153.121,250.234,152.939,250.416Z",
    transform: "translate(-68.007 -63.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8372",
    "data-name": "Path 8372",
    d: "M153.836,267.9a16.138,16.138,0,0,0-3.661-.125c-.144,0-.134.249,0,.259,1.207,0,2.424-.057,3.632,0a.077.077,0,0,0,.029-.134Z",
    transform: "translate(-69.144 -64.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8373",
    "data-name": "Path 8373",
    d: "M139.963,292.8a16.481,16.481,0,0,0-5.673,1.131v.086c1.917-.45,3.766-.632,5.663-.958a.144.144,0,0,0,.01-.259Z",
    transform: "translate(-68.485 -65.622)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8374",
    "data-name": "Path 8374",
    d: "M135.963,284.2a12.675,12.675,0,0,0-2.405.211.077.077,0,0,0,0,.144,11.871,11.871,0,0,0,2.405-.105.125.125,0,1,0,0-.249Z",
    transform: "translate(-68.453 -65.263)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8375",
    "data-name": "Path 8375",
    d: "M66.592,271.889A83.516,83.516,0,0,1,83.7,279.948a51.1,51.1,0,0,1,14.25,13.531,126.684,126.684,0,0,1,18.265,36.884,98.244,98.244,0,0,1,4.14,22.5.22.22,0,0,1-.431,0,127.652,127.652,0,0,0-11.135-38.206c-5.587-11.835-12.63-24.426-23.4-32.265-5.865-4.264-12.458-7.063-19.031-10.014C66.008,272.263,66.247,271.774,66.592,271.889Z",
    transform: "translate(-65.644 -64.748)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8376",
    "data-name": "Path 8376",
    d: "M111.9,321.9A76.929,76.929,0,0,0,98.278,312C90.669,307.779,84.488,305,82.6,301.31s3.986-8.481,3.986-8.481-7.762,3.833-10.982,1.006S65.62,271.46,65.62,271.46s17.929,6.373,29.112,19.3S111.9,321.9,111.9,321.9Z",
    transform: "translate(-65.62 -64.731)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8377",
    "data-name": "Path 8377",
    d: "M111.306,318.059C102.346,301.231,90.377,286,74,276h0a82.663,82.663,0,0,1,12,9.391,19.05,19.05,0,0,0-9.64,2.032.057.057,0,0,0,0,.105,26.352,26.352,0,0,1,9.918-1.677.24.24,0,0,0,.115,0c.585.546,1.15,1.112,1.725,1.677a30.146,30.146,0,0,0-5.156.68s0,.077,0,.077a25.879,25.879,0,0,1,5.433-.45,112.026,112.026,0,0,1,8.462,9.583,8.471,8.471,0,0,0-3.6.259.067.067,0,1,0,0,.134,19.094,19.094,0,0,1,3.833-.048c.489.623.958,1.246,1.466,1.917a34.373,34.373,0,0,0-10.876,1.054c-.058,0,0,.1,0,.086a43.746,43.746,0,0,1,11.241-.862c.46.6.891,1.227,1.342,1.84a23.536,23.536,0,0,0-6.478.747.067.067,0,0,0,0,.125,25,25,0,0,1,6.708-.518c1.917,2.654,3.776,5.376,5.548,8.117a6.1,6.1,0,0,0-2.875.172v.077a12.708,12.708,0,0,1,3.076.153q2.4,3.718,4.619,7.522C111.085,318.442,111.43,318.279,111.306,318.059Z",
    transform: "translate(-65.97 -64.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8378",
    "data-name": "Path 8378",
    d: "M98.153,305.319a13.752,13.752,0,0,0-5.213.642s0,.086,0,.077a39.124,39.124,0,0,1,5.184-.537C98.249,305.5,98.278,305.328,98.153,305.319Z",
    transform: "translate(-66.76 -66.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8379",
    "data-name": "Path 8379",
    d: "M81.953,283.919a8.808,8.808,0,0,0-2.405.134c-.086,0-.057.153,0,.144.8-.086,1.572-.057,2.357-.077a.105.105,0,0,0,.048-.2Z",
    transform: "translate(-66.199 -65.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8380",
    "data-name": "Path 8380",
    d: "M136.278,379.868H95.81l5.769-42.27,1.476-10.838h25.979l1.476,10.838Z",
    transform: "translate(-66.88 -67.038)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8381",
    "data-name": "Path 8381",
    d: "M130.76,337.6H101.83l1.476-10.838h25.979Z",
    transform: "translate(-67.131 -67.038)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 33.405,
    height: 9.18,
    transform: "translate(32.457 255.965)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-38",
    transform: "translate(68.821 368.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8382",
    "data-name": "Path 8382",
    d: "M68.96,382.159l72.839-.23,72.839-.086,145.677-.163,145.677.163,72.839.086,72.839.23-72.839.24-72.839.077-145.677.163-145.677-.163-72.839-.086Z",
    transform: "translate(-68.96 -381.68)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-38",
    transform: "translate(87.315 379.761)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 274.776,
    cy: 30.109,
    rx: 274.776,
    ry: 30.109,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-38",
    transform: "translate(110.503 85.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8383",
    "data-name": "Path 8383",
    d: "M304.943,417.317c-2.233.757-66.255.958-68.708-.556-.958-.575-1.5-9.9-1.917-21.187-.086-2.434-.153-4.954-.211-7.5L229,353.918l42.806-.278L275.84,387.8l-.163,7.513s24.551,10.876,27.062,12.85S307.176,416.56,304.943,417.317Z",
    transform: "translate(-117.32 -97.677)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8384",
    "data-name": "Path 8384",
    d: "M305.167,418.8c-2.233.757-66.255.958-68.708-.556-1.131-.709-1.744-14.326-2.089-28.691l41.647-.268-.163,7.513s24.551,10.876,27.062,12.85S307.4,418.048,305.167,418.8Z",
    transform: "translate(-117.544 -99.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8385",
    "data-name": "Path 8385",
    d: "M305.175,419.132c-2.233.757-66.255.958-68.708-.556-.958-.575-1.5-9.9-1.917-21.187l41.273-.259s24.551,10.876,27.062,12.85S307.408,418.375,305.175,419.132Z",
    transform: "translate(-117.552 -99.492)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8386",
    "data-name": "Path 8386",
    d: "M304.461,417.415c-10.733-.23-54.047-.125-64.674.47-.086,0-.086.057,0,.067,10.637.45,53.951,0,64.674-.364C304.691,417.578,304.691,417.415,304.461,417.415Z",
    transform: "translate(-117.767 -100.334)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8387",
    "data-name": "Path 8387",
    d: "M301.207,408.15a8.624,8.624,0,0,0-6.411,2.645,8.3,8.3,0,0,0-2.377,5.75c0,.067.115.067.125,0a9.966,9.966,0,0,1,8.624-8.241.079.079,0,1,0,.038-.153Z",
    transform: "translate(-119.966 -99.952)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8388",
    "data-name": "Path 8388",
    d: "M281.479,398.23c-4.293-.048-9.267,1.485-11.931,5.012-.1.134.1.278.22.211a59.645,59.645,0,0,1,11.787-4.7.268.268,0,0,0-.077-.527Z",
    transform: "translate(-119.011 -99.538)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8389",
    "data-name": "Path 8389",
    d: "M284.959,399.56c-4.3,0-9.276,1.495-11.931,5.012-.105.144.086.287.22.22a59.021,59.021,0,0,1,11.777-4.705.268.268,0,0,0-.067-.527Z",
    transform: "translate(-119.156 -99.593)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8390",
    "data-name": "Path 8390",
    d: "M288.419,400.9c-4.293,0-9.267,1.485-11.931,5.012-.1.134.1.278.22.211a59.641,59.641,0,0,1,11.787-4.7.268.268,0,0,0-.077-.527Z",
    transform: "translate(-119.3 -99.649)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8391",
    "data-name": "Path 8391",
    d: "M291.889,402.24c-4.3-.048-9.276,1.485-11.931,5.012-.105.134.1.278.22.211a59.418,59.418,0,0,1,11.787-4.7.268.268,0,0,0-.077-.527Z",
    transform: "translate(-119.445 -99.705)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8392",
    "data-name": "Path 8392",
    d: "M242.454,407.26c-4.791,0-4.791,7.522,0,7.494S247.283,407.231,242.454,407.26Z",
    transform: "translate(-117.731 -99.915)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8393",
    "data-name": "Path 8393",
    d: "M286.371,386.218c-2.175-1.8-4.916,0-6.248,1.849a22.6,22.6,0,0,0-3.833,11,.123.123,0,0,0,.134.125.517.517,0,0,0,.776.335c3.047-2.118,6.574-4.015,8.883-7.015C287.4,390.769,288.47,387.895,286.371,386.218Zm-5.232,9.142c-1.476,1.083-3,2.089-4.437,3.229.767-2.147,1.428-4.312,2.405-6.382a24.01,24.01,0,0,1,1.552-2.875c.958-1.428,5.136-5.031,5.577-.364C286.486,391.526,282.892,394.075,281.139,395.359Z",
    transform: "translate(-119.293 -99.006)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8394",
    "data-name": "Path 8394",
    d: "M264.93,401.036c3.737.556,7.6-.517,11.269-1.1a.527.527,0,0,0,.316-.786.115.115,0,0,0,0-.182,22.52,22.52,0,0,0-10.407-5.242c-2.261-.431-5.462.192-5.75,3C260.014,399.369,262.745,400.691,264.93,401.036Zm-2.607-2.434c-2.875-3.68,2.616-4,4.264-3.613a24.509,24.509,0,0,1,3.143,1.016,66.665,66.665,0,0,1,6.143,2.923c-1.821.182-3.613.508-5.424.757C268.284,399.973,263.933,400.624,262.323,398.6Z",
    transform: "translate(-118.627 -99.345)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8395",
    "data-name": "Path 8395",
    d: "M163.32,189.2s49.706,84.558,51.038,90.5c2.041,9.123,12.86,99.21,12.86,99.21l51.747-.958s-8.912-79.431-17.354-105.6c-6.075-18.849-49.945-81.367-49.945-81.367Z",
    transform: "translate(-114.58 -90.816)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8396",
    "data-name": "Path 8396",
    d: "M277.188,377.926c-7.427-.057-33.75-.355-43.64.565-.077,0-.067.134,0,.144,3.4.489,36.2-.268,43.63-.508a.105.105,0,1,0,.01-.2Z",
    transform: "translate(-117.507 -98.687)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8397",
    "data-name": "Path 8397",
    d: "M172.162,197.3c3.258,5.108,6.708,10.11,10.024,15.179s6.65,10.139,9.937,15.2q9.832,15.332,19.166,30.866a94.51,94.51,0,0,1,7.762,15.131,92.712,92.712,0,0,1,4.36,16.233c1.016,5.548,1.687,11.154,2.309,16.76q.958,8.941,2,17.891,2.041,18.313,4.092,36.625c.163,1.495.326,2.99.479,4.494a.2.2,0,0,1-.4,0c-1.524-12.122-2.789-24.292-4.169-36.414q-1.035-9.075-2.06-18.14c-.642-5.625-1.255-11.26-2.127-16.846a110.2,110.2,0,0,0-3.641-16.291,78.24,78.24,0,0,0-7.149-15.812c-5.989-10.34-12.333-20.5-18.677-30.665s-12.86-20.421-19.549-30.464c-.824-1.236-1.658-2.472-2.52-3.689C171.932,197.289,172.1,197.2,172.162,197.3Z",
    transform: "translate(-114.941 -91.153)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8398",
    "data-name": "Path 8398",
    d: "M177.489,421.693c-2.357-.144-63.246-24.81-64.933-27.148a.805.805,0,0,1-.1-.45c0-2.1,4.226-9.42,7.752-19.041.22-.613,1.792-3.469,3.967-7.312,6.047-10.531,16.588-28.672,16.588-28.672l39.8,15.812L161.514,383.39l-2.961,6.9S177.23,409.6,178.8,412.33,179.836,421.827,177.489,421.693Z",
    transform: "translate(-112.457 -97.07)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8399",
    "data-name": "Path 8399",
    d: "M177.489,422.941c-2.357-.144-63.246-24.81-64.933-27.148a.805.805,0,0,1-.1-.45c0-2.1,4.226-9.42,7.752-19.041.22-.613,1.792-3.469,3.967-7.312l37.373,15.649-2.961,6.9s18.677,19.309,20.248,22.04S179.836,423.075,177.489,422.941Z",
    transform: "translate(-112.457 -98.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8400",
    "data-name": "Path 8400",
    d: "M177.489,423.259c-2.357-.144-63.246-24.81-64.933-27.148-.652-.891,2.07-9.2,7.666-19.491l38.331,15.246s18.677,19.29,20.258,22.04S179.836,423.393,177.489,423.259Z",
    transform: "translate(-112.457 -98.636)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8401",
    "data-name": "Path 8401",
    d: "M177.8,421.413c-9.861-4.236-50.051-20.392-60.122-23.823-.086,0-.105,0,0,.058,9.688,4.408,50,20.239,60.084,23.957C177.952,421.652,178.01,421.5,177.8,421.413Z",
    transform: "translate(-112.672 -99.511)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8402",
    "data-name": "Path 8402",
    d: "M178.128,411.688a8.624,8.624,0,0,0-6.938,0,8.337,8.337,0,0,0-4.351,4.427c0,.057.086.105.115.048a9.976,9.976,0,0,1,11.126-4.4A.067.067,0,0,0,178.128,411.688Z",
    transform: "translate(-114.726 -100.069)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8403",
    "data-name": "Path 8403",
    d: "M163.624,395.12c-3.958-1.658-9.152-2.1-12.937.172-.144.086,0,.287.125.278a59.744,59.744,0,0,1,12.688.067.268.268,0,0,0,.125-.517Z",
    transform: "translate(-114.05 -99.35)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8404",
    "data-name": "Path 8404",
    d: "M166.334,397.66c-3.958-1.658-9.152-2.1-12.937.172-.144.086,0,.287.125.278a59.119,59.119,0,0,1,12.688.067.268.268,0,0,0,.125-.517Z",
    transform: "translate(-114.163 -99.456)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8405",
    "data-name": "Path 8405",
    d: "M169.054,400.2c-3.967-1.658-9.161-2.1-12.937.172-.153.086,0,.287.115.278a59.115,59.115,0,0,1,12.688.067.268.268,0,0,0,.134-.517Z",
    transform: "translate(-114.276 -99.562)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8406",
    "data-name": "Path 8406",
    d: "M171.764,402.739c-3.967-1.658-9.152-2.1-12.937.163-.153.1,0,.3.115.287a59.119,59.119,0,0,1,12.688.067.268.268,0,0,0,.134-.517Z",
    transform: "translate(-114.389 -99.668)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8407",
    "data-name": "Path 8407",
    d: "M124.06,388.757c-4.475-1.782-7.254,5.184-2.76,6.967S128.583,390.54,124.06,388.757Z",
    transform: "translate(-112.731 -99.131)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8408",
    "data-name": "Path 8408",
    d: "M172.523,385.806c-1.351-2.482-4.542-1.869-6.488-.632a22.538,22.538,0,0,0-7.666,8.749.115.115,0,0,0,.077.163c0,.316.211.69.585.613,3.632-.834,7.609-1.265,10.867-3.181C171.766,390.405,173.8,388.153,172.523,385.806Zm-8.289,6.507c-1.773.45-3.555.815-5.309,1.332a67.018,67.018,0,0,1,4.609-5.012,24.3,24.3,0,0,1,2.539-2.108c1.389-.958,6.641-2.731,5.3,1.763C170.635,390.769,166.352,391.776,164.234,392.312Z",
    transform: "translate(-114.372 -98.948)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8409",
    "data-name": "Path 8409",
    d: "M147.237,391.427c3.258,1.917,7.235,2.367,10.857,3.21.374.086.623-.287.594-.613a.105.105,0,0,0,.077-.163,22.539,22.539,0,0,0-7.666-8.768c-1.917-1.246-5.127-1.869-6.488.6S145.33,390.305,147.237,391.427Zm-1.495-3.239c-1.332-4.494,3.91-2.712,5.3-1.744a23.317,23.317,0,0,1,2.53,2.118,67.076,67.076,0,0,1,4.6,5.021c-1.754-.517-3.536-.891-5.309-1.342C150.715,391.666,146.47,390.708,145.742,388.188Z",
    transform: "translate(-113.781 -98.944)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8410",
    "data-name": "Path 8410",
    d: "M164.94,374.786,120.39,356.8s55.235-81.214,55.637-87.261c.364-5.347-23.9-51.939-24.848-65.517-1.035-14.662,6.018-26,13.78-33.041l45.949,19.539s-4.849,7.752-12.458,12.074c0,0,23.564,53.855,22.222,70.414S164.94,374.786,164.94,374.786Z",
    transform: "translate(-112.788 -90.056)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8411",
    "data-name": "Path 8411",
    d: "M167.274,374.146c-6.44-2.769-4.552-2.07-11.03-4.791-3.162-1.322-23.957-9.976-27.158-10.694-.067,0-.115.1-.048.134,2.769,1.7,23.736,9.985,26.928,11.25,6.526,2.568,4.676,1.763,11.231,4.255a.1.1,0,1,0,.077-.153Z",
    transform: "translate(-113.148 -97.887)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8412",
    "data-name": "Path 8412",
    d: "M209.1,202.94a86.726,86.726,0,0,0-13.991,4.542.147.147,0,0,0,.1.278c4.7-1.37,9.468-2.654,14.087-4.274C209.643,203.361,209.461,202.863,209.1,202.94Z",
    transform: "translate(-115.902 -91.389)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8413",
    "data-name": "Path 8413",
    d: "M203.922,200.989a20.747,20.747,0,0,0-1.179,2.463,5.664,5.664,0,0,0-.6,2.06c0,.144.192.172.278.086a7.2,7.2,0,0,0,1.15-1.917c.393-.757.8-1.5,1.169-2.281A.456.456,0,1,0,203.922,200.989Z",
    transform: "translate(-116.199 -91.298)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8414",
    "data-name": "Path 8414",
    d: "M204.539,196.271c.288-.709.565-1.409.862-2.118s.671-1.437.958-2.185c0-.115.23,0,.182.086-.287.709-.47,1.457-.69,2.185s-.47,1.457-.709,2.185a35.46,35.46,0,0,1-1.581,4.006,5.079,5.079,0,0,0,2.2-.383,3.958,3.958,0,0,0,1.562-1.917c.4-.786.776-1.591,1.188-2.377a15.88,15.88,0,0,0,1.274-2.674c0-.115.23,0,.182.086a31.1,31.1,0,0,1-2.444,5.663c-.431.7-.767,1.437-1.552,1.706a6.5,6.5,0,0,1-2.616.182c-.115,0-.249,0-.211-.172Q203.738,198.374,204.539,196.271Z",
    transform: "translate(-116.241 -90.93)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8415",
    "data-name": "Path 8415",
    d: "M202.553,205.8c1.639,3.459,3.076,6.909,4.6,10.359s2.875,6.785,4.245,10.215c2.741,6.919,5.194,13.972,7.35,21.082,1.064,3.526,2.051,7.082,2.932,10.666a76.663,76.663,0,0,1,2.127,10.886,28.749,28.749,0,0,1-.958,10.924,63.894,63.894,0,0,1-4.054,10.186c-1.006,2.07-1.342,1.792-.862.747,1.37-2.971,4.964-11.969,4.705-19.53a56.368,56.368,0,0,0-1.667-10.723q-1.255-5.433-2.827-10.781c-2.041-7.034-4.466-13.924-6.957-20.8-1.4-3.833-2.875-7.666-4.312-11.5s-2.875-7.36-4.485-11.6C202.342,205.759,202.5,205.692,202.553,205.8Z",
    transform: "translate(-116.209 -91.507)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8416",
    "data-name": "Path 8416",
    d: "M167.265,193.452c.8-.3,1.917.192,2.721.326a23.262,23.262,0,0,0,3.153.316,22.787,22.787,0,0,0,3.134-.105,6.708,6.708,0,0,0,3-.8,15.265,15.265,0,0,0,3.833-4.054,23.584,23.584,0,0,0,2.98-5.232c0-.115.2,0,.163.077-.335,1.064-.585,2.137-.958,3.181a19.315,19.315,0,0,1-1.476,2.827,12.084,12.084,0,0,1-3.967,4.5c-1.849,1.054-4.226.958-6.286.872a24.553,24.553,0,0,1-3.555-.47c-.843-.182-2.262-.316-2.8-1.054a.259.259,0,0,1,.057-.393Z",
    transform: "translate(-114.739 -90.594)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8417",
    "data-name": "Path 8417",
    d: "M133.659,348.449q10.982-16.636,21.561-33.54t20.871-34.067c1.639-2.731,3.526-5.453,4.581-8.481,1.15-3.287.5-6.478-.537-9.7a164.473,164.473,0,0,0-6.842-17.249c-2.568-5.663-5.338-11.231-8.059-16.818a172.983,172.983,0,0,1-7.666-16.933c-1.917-5.568-2.693-11.336-1.2-17.105s4.715-10.867,8.078-15.668c.882-1.265,1.792-2.52,2.683-3.833.067-.1.211,0,.144.115-3.709,5-7.321,10.3-9.5,16.176a27.933,27.933,0,0,0-1.84,9.056,29.313,29.313,0,0,0,1.447,9.266c1.8,5.826,4.648,11.336,7.3,16.818s5.491,11.154,8.107,16.8a179.812,179.812,0,0,1,7.187,17.431c.891,2.635,1.917,5.4,1.84,8.222-.067,3.1-1.543,5.884-3.076,8.49q-10.062,17.033-20.574,33.731c-7,11.154-14.192,22.309-21.475,33.348l-2.76,4.169C133.793,348.851,133.544,348.65,133.659,348.449Z",
    transform: "translate(-113.341 -90.225)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8418",
    "data-name": "Path 8418",
    d: "M217.46,137.154c4.149,9.1,25.107,21.647,34.92,23,7.053.958,28.5,1.3,35.849.182,8.624-1.322,2.032-24.561-3.057-23.957-13.991,1.629-25.873,3.45-29.611,3.45-4.561,0-29.237-7.915-32.208-9.037C216.071,128.079,215.113,131.989,217.46,137.154Z",
    transform: "translate(-116.791 -88.342)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8419",
    "data-name": "Path 8419",
    d: "M217.523,139.542c5.251,7.772,22.7,20.478,22.7,20.478l2.424-5.366,8.021-17.747s-16.032-5.031-26.583-7.331a23.112,23.112,0,0,0-3.776-.537C213.574,128.675,212.99,132.834,217.523,139.542Z",
    transform: "translate(-116.719 -88.305)",
    fill: "#ff9800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8420",
    "data-name": "Path 8420",
    d: "M217.523,139.542c5.251,7.772,22.7,20.478,22.7,20.478l2.424-5.366c-6.507-7.561-16.559-19.012-22.337-25.6C213.574,128.676,212.99,132.835,217.523,139.542Z",
    transform: "translate(-116.719 -88.306)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8421",
    "data-name": "Path 8421",
    d: "M238.059,156.77c1.332-3.268,7.254-16.425,8.73-19.166.1-.192.249-.172.163,0a193.289,193.289,0,0,1-8.759,19.166C238.155,156.885,238,156.846,238.059,156.77Z",
    transform: "translate(-117.697 -88.658)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8422",
    "data-name": "Path 8422",
    d: "M285.49,136.846c8.509-1.112,19.041-3.019,27.962.767a4.791,4.791,0,0,1,2.386,2.041c4.025,1.629,4.466,4.015,4.466,4.015,3.287,2.664,3.4,5.175,3.4,5.175s4.715,1.917,4,5c-.786,3.411-7.245,0-11.94.278-10.781.671-25.873,4.628-28.988,5.127Z",
    transform: "translate(-119.677 -88.57)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8423",
    "data-name": "Path 8423",
    d: "M304.775,147.362a69.383,69.383,0,0,1,9.468,0,68.88,68.88,0,0,1,10.158,2.06.086.086,0,1,0,.057-.163,36.692,36.692,0,0,0-19.683-1.993C304.622,147.247,304.622,147.372,304.775,147.362Z",
    transform: "translate(-120.477 -89.044)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8424",
    "data-name": "Path 8424",
    d: "M303.373,140.658c3.1,0,8.538.153,17.642,3.325v-.057a32.974,32.974,0,0,0-17.661-3.421C303.182,140.524,303.162,140.649,303.373,140.658Z",
    transform: "translate(-120.417 -88.78)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8425",
    "data-name": "Path 8425",
    d: "M302.683,136.99a51.5,51.5,0,0,1,13.837,2.7v-.057c-5.826-2.434-8.212-2.664-13.866-2.875C302.472,136.837,302.482,136.99,302.683,136.99Z",
    transform: "translate(-120.388 -88.628)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8426",
    "data-name": "Path 8426",
    d: "M302.881,156.64c-1.37.642-1.035,1.361,1.581,1.964s13.493.786,13.109,4.581-15.725,3.316-20.009,1.974a71.944,71.944,0,0,1-10.733-5.021C289.868,159.63,297,157.7,302.881,156.64Z",
    transform: "translate(-119.733 -89.458)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8427",
    "data-name": "Path 8427",
    d: "M229.26,152.607c-.067,1.639-.22,3.306-.45,4.964a.2.2,0,0,1,.067-.182c.316-.862.632-1.744,1.016-2.578h.086a13.821,13.821,0,0,1-.824,2.664c-.172.412-.335.815-.517,1.217-.115.738-.249,1.466-.393,2.194-.287,1.37-1.581,7.2-1.917,8.184-.057.2-.307.153-.287-.077.067-1.073,1.15-7.139,1.37-8.519a74.472,74.472,0,0,1,1.715-7.906C229.174,152.521,229.269,152.559,229.26,152.607Z",
    transform: "translate(-117.196 -89.287)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8428",
    "data-name": "Path 8428",
    d: "M216.6,195.054c-2.559,1.313-5.855,3.354-20.708.431-.958-.192-1.859-.422-2.8-.7-13.924-4.178-30.665-20.555-31.575-21.715,0,0,22.127-35.868,50.424-47.147,3.5-1.389,9.286,1.294,12.458,4.638,1.14,1.2,3.622,10,2.674,17.134S219.151,193.741,216.6,195.054Z",
    transform: "translate(-114.504 -88.161)",
    fill: "#ff9800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8429",
    "data-name": "Path 8429",
    d: "M216.891,148.32a10.868,10.868,0,0,1-.623,4.466A10.4,10.4,0,0,1,216.891,148.32Z",
    transform: "translate(-116.787 -89.111)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8430",
    "data-name": "Path 8430",
    d: "M206.821,173.81a9.9,9.9,0,0,1-.077,2.262,9.392,9.392,0,0,1-.546,2.2,9.439,9.439,0,0,1,.077-2.271A9.936,9.936,0,0,1,206.821,173.81Z",
    transform: "translate(-116.367 -90.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8431",
    "data-name": "Path 8431",
    d: "M189.711,154.54a10.877,10.877,0,0,1-.623,4.475A10.474,10.474,0,0,1,189.711,154.54Z",
    transform: "translate(-115.653 -89.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8432",
    "data-name": "Path 8432",
    d: "M223.481,172.51a9.959,9.959,0,0,1-.077,2.271,9.392,9.392,0,0,1-.546,2.2,9.442,9.442,0,0,1,.077-2.271,9.889,9.889,0,0,1,.546-2.2Z",
    transform: "translate(-117.062 -90.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8433",
    "data-name": "Path 8433",
    d: "M201.54,151.238a9.9,9.9,0,0,1,2.262.067,9.419,9.419,0,0,1,2.2.556,10.8,10.8,0,0,1-4.466-.623Z",
    transform: "translate(-116.174 -89.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8434",
    "data-name": "Path 8434",
    d: "M182.12,169.649a10.866,10.866,0,0,1,4.466.623,10.4,10.4,0,0,1-4.466-.623Z",
    transform: "translate(-115.364 -90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8435",
    "data-name": "Path 8435",
    d: "M205,189.579a10.8,10.8,0,0,1,4.466.623,10.455,10.455,0,0,1-4.466-.623Z",
    transform: "translate(-116.319 -90.831)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8436",
    "data-name": "Path 8436",
    d: "M176.13,182.339a10.867,10.867,0,0,1,4.466.623A10.454,10.454,0,0,1,176.13,182.339Z",
    transform: "translate(-115.114 -90.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8437",
    "data-name": "Path 8437",
    d: "M216.77,130.4a10.867,10.867,0,0,1,4.466.623A10.867,10.867,0,0,1,216.77,130.4Z",
    transform: "translate(-116.81 -88.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8438",
    "data-name": "Path 8438",
    d: "M210.965,136.78a9.343,9.343,0,0,1-1.648,1.552A10.177,10.177,0,0,1,207.4,139.5a9.747,9.747,0,0,1,1.629-1.552,10.1,10.1,0,0,1,1.936-1.169Z",
    transform: "translate(-116.419 -88.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8439",
    "data-name": "Path 8439",
    d: "M180.174,154.91a9.688,9.688,0,0,1-1.658,1.543,9.037,9.037,0,0,1-1.917,1.169,10.088,10.088,0,0,1,1.658-1.543A9.275,9.275,0,0,1,180.174,154.91Z",
    transform: "translate(-115.134 -89.386)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8440",
    "data-name": "Path 8440",
    d: "M218.624,163.09a9.744,9.744,0,0,1-1.658,1.552,9.278,9.278,0,0,1-1.917,1.169,9.746,9.746,0,0,1,1.658-1.552,9.887,9.887,0,0,1,1.917-1.169Z",
    transform: "translate(-116.738 -89.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8441",
    "data-name": "Path 8441",
    d: "M193.724,178.77a9.744,9.744,0,0,1-1.658,1.552,9.447,9.447,0,0,1-1.917,1.169,9.745,9.745,0,0,1,1.658-1.552A9.887,9.887,0,0,1,193.724,178.77Z",
    transform: "translate(-115.699 -90.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8442",
    "data-name": "Path 8442",
    d: "M228.164,141.67a9.745,9.745,0,0,1-1.658,1.552,10.177,10.177,0,0,1-1.917,1.169,9.747,9.747,0,0,1,1.658-1.552A9.45,9.45,0,0,1,228.164,141.67Z",
    transform: "translate(-117.136 -88.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8443",
    "data-name": "Path 8443",
    d: "M227.682,159.684a9.745,9.745,0,0,1-1.552-1.658,9.21,9.21,0,0,1-1.169-1.917,9.344,9.344,0,0,1,1.552,1.648,10.472,10.472,0,0,1,1.169,1.926Z",
    transform: "translate(-117.151 -89.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8444",
    "data-name": "Path 8444",
    d: "M172.182,172.2a9.746,9.746,0,0,1-1.552-1.658,9.888,9.888,0,0,1-1.169-1.917,9.744,9.744,0,0,1,1.552,1.658,9.449,9.449,0,0,1,1.169,1.917Z",
    transform: "translate(-114.836 -89.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8445",
    "data-name": "Path 8445",
    d: "M220.932,187.095a9.343,9.343,0,0,1-1.552-1.648,10.178,10.178,0,0,1-1.169-1.917,9.748,9.748,0,0,1,1.552,1.658A9.63,9.63,0,0,1,220.932,187.095Z",
    transform: "translate(-116.87 -90.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8446",
    "data-name": "Path 8446",
    d: "M196.5,144.645A9.687,9.687,0,0,1,194.949,143a10.476,10.476,0,0,1-1.169-1.917,9.34,9.34,0,0,1,1.552,1.648,10.476,10.476,0,0,1,1.169,1.917Z",
    transform: "translate(-115.85 -88.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8447",
    "data-name": "Path 8447",
    d: "M196.932,195.574a9.746,9.746,0,0,1-1.552-1.658A10.1,10.1,0,0,1,194.21,192a9.341,9.341,0,0,1,1.552,1.648,9.985,9.985,0,0,1,1.169,1.926Z",
    transform: "translate(-115.868 -90.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8448",
    "data-name": "Path 8448",
    d: "M201.082,165.534a10.091,10.091,0,0,1-1.543-1.658,9.037,9.037,0,0,1-1.169-1.917,9.689,9.689,0,0,1,1.543,1.658,9.275,9.275,0,0,1,1.169,1.917Z",
    transform: "translate(-116.042 -89.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8449",
    "data-name": "Path 8449",
    d: "M221.406,139.6c-3.613-.671-7-8.136-7.436-13.157,0-.345,1.687-3.076,3.613-6.5,1.169-2.079,2.405-4.427,3.392-6.65.2-.45,1.38,1.073,1.38,1.073l2.568,1.917,8.481,6.507a38.658,38.658,0,0,0-5.108,7.925,4.791,4.791,0,0,0-.307.958,1.161,1.161,0,0,0,0,.163C227.463,133.736,224.885,140.243,221.406,139.6Z",
    transform: "translate(-116.693 -87.646)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8450",
    "data-name": "Path 8450",
    d: "M228.271,131.781a1.17,1.17,0,0,0,0,.163,9.5,9.5,0,0,1-1.466-.565c-9.286-4.351-5.194-16.789-5.194-16.789l3.641,1.8,8.481,6.507a38.654,38.654,0,0,0-5.108,7.925A4.792,4.792,0,0,0,228.271,131.781Z",
    transform: "translate(-116.974 -87.703)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8451",
    "data-name": "Path 8451",
    d: "M244.42,95.58s4.245,2.693,4.264,7.484-1.917,9.477-2.319,9.65S244.42,95.58,244.42,95.58Z",
    transform: "translate(-117.963 -86.91)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8452",
    "data-name": "Path 8452",
    d: "M222.363,97.892c-2.549,5.031-2.415,20.89.767,24.973,4.619,5.922,13.512,7.963,18.888,2.108,5.2-5.673,4.667-26.333.958-30.186C237.58,89.095,226.138,90.446,222.363,97.892Z",
    transform: "translate(-116.969 -86.73)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8453",
    "data-name": "Path 8453",
    d: "M222.87,124h0",
    transform: "translate(-117.064 -88.096)",
    fill: "none",
    stroke: "#f5a79e",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8454",
    "data-name": "Path 8454",
    d: "M236.512,111.43s-.086.057-.077.1c.058,1.083-.057,2.329-1.025,2.712v.057C236.608,114.1,236.742,112.446,236.512,111.43Z",
    transform: "translate(-117.587 -87.572)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8455",
    "data-name": "Path 8455",
    d: "M235.471,110.28c-1.744-.1-1.8,3.392-.182,3.479S236.928,110.357,235.471,110.28Z",
    transform: "translate(-117.533 -87.523)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8456",
    "data-name": "Path 8456",
    d: "M242.726,111.39a.088.088,0,0,1,.086.1c-.057,1.083.067,2.329,1.045,2.7v.057C242.65,114.064,242.506,112.406,242.726,111.39Z",
    transform: "translate(-117.889 -87.57)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8457",
    "data-name": "Path 8457",
    d: "M243.714,110.23c1.734-.105,1.821,3.383.211,3.479S242.258,110.316,243.714,110.23Z",
    transform: "translate(-117.89 -87.521)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8458",
    "data-name": "Path 8458",
    d: "M234.348,107.4a14.037,14.037,0,0,0,1.351-.46,2.3,2.3,0,0,0,1.3-.728.738.738,0,0,0-.105-.891,1.83,1.83,0,0,0-1.84-.22,2.712,2.712,0,0,0-1.572,1.14.8.8,0,0,0,.862,1.159Z",
    transform: "translate(-117.503 -87.301)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8459",
    "data-name": "Path 8459",
    d: "M244.876,109.017a14.035,14.035,0,0,1-1.38-.383,2.3,2.3,0,0,1-1.332-.661.719.719,0,0,1,.057-.891,1.811,1.811,0,0,1,1.821-.316,2.683,2.683,0,0,1,1.629,1.054.786.786,0,0,1-.8,1.2Z",
    transform: "translate(-117.864 -87.372)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8460",
    "data-name": "Path 8460",
    d: "M233.993,122.118c.259.259.508.6.9.642a2.875,2.875,0,0,0,1.169-.249s.067,0,0,.057a1.447,1.447,0,0,1-1.38.565,1.16,1.16,0,0,1-.843-.958.082.082,0,0,1,.153-.057Z",
    transform: "translate(-117.522 -88.015)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8461",
    "data-name": "Path 8461",
    d: "M240.337,116.845s.048,1.61,0,2.367a15.793,15.793,0,0,0-4.418.153c-.345.077-.307-.2.086-.383a6.478,6.478,0,0,1,3.756-.5c.077-.2-.125-2.491,0-2.482a6.4,6.4,0,0,1,1.667.575c0-3.373-.537-6.708-.489-10.081a.1.1,0,0,1,.2,0,54.278,54.278,0,0,1,.958,10.829C242.11,117.737,240.625,117,240.337,116.845Z",
    transform: "translate(-117.599 -87.362)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8462",
    "data-name": "Path 8462",
    d: "M238.144,119.169a4.792,4.792,0,0,1-2.012,2.405c-1.447.585-1.917-.728-.46-1.917A4.677,4.677,0,0,1,238.144,119.169Z",
    transform: "translate(-117.561 -87.894)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8463",
    "data-name": "Path 8463",
    d: "M236.639,121.313a1.917,1.917,0,0,1-.508.3c-1.332.537-1.859-.527-.786-1.6C236.073,120.067,236.907,120.336,236.639,121.313Z",
    transform: "translate(-117.561 -87.93)",
    fill: "#ff99ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8464",
    "data-name": "Path 8464",
    d: "M221.563,111.254c1.754.537,3.766-4.734,4.341-6.708.5-1.782,1.073-7.446,1.16-7.839s7.666,5.012,12.055,3.728,7.369-5.261,7.436-7.11-5.424-6.545-10.167-6.785-11.173,5.75-11.173,5.75a22.039,22.039,0,0,0,2.108-2.817c-.077-.211-3.143,1.016-3.709,3.2,0,0,.613-2.75.383-2.8s-2.616,2.3-2.079,4.082c0,0-2.76,2.386-3.009,5S219.5,110.621,221.563,111.254Z",
    transform: "translate(-116.897 -86.533)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8465",
    "data-name": "Path 8465",
    d: "M242.544,99.8a14.576,14.576,0,0,1-4.169,1.495,9.9,9.9,0,0,1-4.791-.767,14.719,14.719,0,0,1-4.178-2.472c-1.1-.9-2.089-2-3.268-2.808-.3-.211-.632.22-.45.489a15.831,15.831,0,0,0,8.011,5.9,9.132,9.132,0,0,0,8.835-1.8S242.563,99.8,242.544,99.8Z",
    transform: "translate(-117.18 -86.894)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8466",
    "data-name": "Path 8466",
    d: "M223.31,111.634s-2.721-5.52-5.175-4.628-.958,8.529,1.562,9.928a2.731,2.731,0,0,0,3.833-.9Z",
    transform: "translate(-116.814 -87.383)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8467",
    "data-name": "Path 8467",
    d: "M218.7,109.28s-.058,0,0,.077c1.744,1.035,2.453,2.875,2.875,4.791a1.5,1.5,0,0,0-2.166-.747c-.057,0,0,.105,0,.105a1.677,1.677,0,0,1,1.734.862,8.1,8.1,0,0,1,.652,1.61c.057.182.374.134.345-.067h0C222.551,113.525,221.21,109.912,218.7,109.28Z",
    transform: "translate(-116.889 -87.482)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8468",
    "data-name": "Path 8468",
    d: "M204.831,137.39c-1.917,10.857,9.851,47.435,17.393,54.267,11.221,10.158,31.968,16.837,39.491,19.012,3.277.958,12.343-22.107,9.027-23.631-7.1-3.229-29.16-10.129-31.259-11.854s-14.748-20-20.383-30.521C211.558,130.5,205.78,131.9,204.831,137.39Z",
    transform: "translate(-116.303 -88.492)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8469",
    "data-name": "Path 8469",
    d: "M267.218,187.25s9.794,2.5,16.109,4.427c3.526,1.083,9.41,3.469,11.643,5.443,3.335,2.961,15.39,17.45,11.94,20.45-3.124,2.721-11.9-11.049-11.9-11.049s10.081,13.109,5.75,15.687-12.256-14.3-12.256-14.3,10.052,13.7,5.136,15.649c-3.718,1.466-11.691-13.416-11.691-13.416s8.567,11.835,4.791,13.512c-4.159,1.859-12.371-11.423-12.371-11.423-10.273,2.654-16.291-.288-20.248-2.875C253.189,208.725,267.218,187.25,267.218,187.25Z",
    transform: "translate(-118.366 -90.735)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8470",
    "data-name": "Path 8470",
    d: "M293.447,202.389c1.246,1.495,2.511,3.009,3.613,4.609s2.147,3.249,3.1,4.945a33.172,33.172,0,0,1,3.066,6.957c-1.648-4.216-5.51-10.014-6.612-11.614s-2.127-3.258-3.22-4.858C293.361,202.389,293.418,202.351,293.447,202.389Z",
    transform: "translate(-120.006 -91.366)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8471",
    "data-name": "Path 8471",
    d: "M287.338,206.439c2.127,1.687,6.583,7.954,8.3,12.161.077.172,0,.163-.125,0-1.342-2.079-6.785-10.129-8.222-12.132C287.261,206.439,287.309,206.411,287.338,206.439Z",
    transform: "translate(-119.752 -91.535)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8472",
    "data-name": "Path 8472",
    d: "M281.465,209a30.023,30.023,0,0,1,6.152,9.583c.067.172-.067.144-.173,0-1.984-3.229-3.517-5.75-6.085-9.5C281.321,209,281.408,208.912,281.465,209Z",
    transform: "translate(-119.504 -91.641)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8473",
    "data-name": "Path 8473",
    d: "M215.453,138.075c-8.749-12.371-13.981-7.791-12.228,5.644,1.648,12.563,6.047,27.531,6.047,27.531l22.04-10.694S221.02,146,215.453,138.075Z",
    transform: "translate(-116.23 -88.382)",
    fill: "#ff9800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8474",
    "data-name": "Path 8474",
    d: "M221.549,143.47a9.849,9.849,0,0,1,.623,2.175,9.955,9.955,0,0,1,.144,2.271,9.907,9.907,0,0,1-.613-2.185A9.362,9.362,0,0,1,221.549,143.47Z",
    transform: "translate(-117.009 -88.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8475",
    "data-name": "Path 8475",
    d: "M207.92,151.286a10.541,10.541,0,0,1,4.437-.767,9.832,9.832,0,0,1-2.175.613A9.392,9.392,0,0,1,207.92,151.286Z",
    transform: "translate(-116.44 -89.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8476",
    "data-name": "Path 8476",
    d: "M208.4,131.24a10.694,10.694,0,0,1-2.6,3.689,10.694,10.694,0,0,1,2.6-3.689Z",
    transform: "translate(-116.352 -88.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8477",
    "data-name": "Path 8477",
    d: "M227.887,157.35a10,10,0,0,1-1.1,1.984,9.687,9.687,0,0,1-1.495,1.706,10.694,10.694,0,0,1,2.6-3.689Z",
    transform: "translate(-117.165 -89.487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8478",
    "data-name": "Path 8478",
    d: "M211.839,165.067a10.7,10.7,0,0,1-3.689-2.6,10.694,10.694,0,0,1,3.689,2.6Z",
    transform: "translate(-116.45 -89.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8479",
    "data-name": "Path 8479",
    d: "M219,142.28c1.179,1.619,2.4,3.2,3.6,4.791q-.46-1.207-.8-2.444h.057c.24.632.517,1.255.747,1.917l.345.958a1.723,1.723,0,0,1,.077.2c.958,1.236,1.917,2.472,2.8,3.737,1.083,1.514,2.127,3.047,3.181,4.581s2.118,3.44,3.258,4.983c.105.134-1.917.958-2.137,1.064s-.335-.077-.125-.144,1.821-1.054,1.84-1.073c-1.054-1.552-2.271-2.98-3.373-4.485s-2.194-3.009-3.258-4.533c-2.156-3.1-4.13-6.325-6.277-9.439Z",
    transform: "translate(-116.9 -88.859)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8480",
    "data-name": "Path 8480",
    d: "M203.773,153.369a20.605,20.605,0,0,1,.958,1.964l.364.834c-.508-2.386-.958-4.791-1.485-7.177h0c1.016,3.833,2.041,7.752,2.98,11.643.891,3.718,1.974,7.475,2.492,11.269a12.506,12.506,0,0,1,2.07-.7,10.215,10.215,0,0,1-2.281,1.1A119.6,119.6,0,0,1,206,160.576c-.24-1.073-.46-2.147-.69-3.22-.249-.652-.546-1.275-.843-1.917s-.565-1.361-.834-2.041C203.687,153.36,203.754,153.321,203.773,153.369Z",
    transform: "translate(-116.261 -89.139)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8481",
    "data-name": "Path 8481",
    d: "M209.888,168.731c3.066-1.725,15.879-8.356,18.744-9.583.2-.086.307,0,.105.134a193.154,193.154,0,0,1-18.782,9.583C209.879,168.885,209.8,168.779,209.888,168.731Z",
    transform: "translate(-116.521 -89.561)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-38",
    transform: "translate(220.439 152.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8482",
    "data-name": "Path 8482",
    d: "M563.608,421.625H271.64L313.852,182.2H605.82Z",
    transform: "translate(-229.035 -157.4)",
    fill: "#ff9800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8483",
    "data-name": "Path 8483",
    d: "M415.619,156.32h-95.55l-4.379,24.8H417.948Z",
    transform: "translate(-230.873 -156.32)",
    fill: "#ff9800"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9085",
    "data-name": "Group 9085",
    transform: "translate(42.605)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8484",
    "data-name": "Path 8484",
    d: "M563.608,421.625H271.64L313.852,182.2H605.82Z",
    transform: "translate(-271.64 -157.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8485",
    "data-name": "Path 8485",
    d: "M415.619,156.32h-95.55l-4.379,24.8H417.948Z",
    transform: "translate(-273.478 -156.32)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8486",
    "data-name": "Path 8486",
    d: "M309.479,166.517a18.369,18.369,0,0,1,0-8.337,18.369,18.369,0,0,1,0,8.337Z",
    transform: "translate(-230.594 -156.398)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8487",
    "data-name": "Path 8487",
    d: "M300.458,169.126a16.292,16.292,0,0,1-2.5-3.373,16.628,16.628,0,0,1-1.677-3.833,15.889,15.889,0,0,1,2.5,3.364A16.876,16.876,0,0,1,300.458,169.126Z",
    transform: "translate(-230.063 -156.554)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8488",
    "data-name": "Path 8488",
    d: "M293.926,175.908a18.379,18.379,0,0,1-7.216-4.169,16.446,16.446,0,0,1,3.833,1.667A16.847,16.847,0,0,1,293.926,175.908Z",
    transform: "translate(-229.664 -156.963)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8489",
    "data-name": "Path 8489",
    d: "M291.637,185.029a18.371,18.371,0,0,1-8.337,0A18.371,18.371,0,0,1,291.637,185.029Z",
    transform: "translate(-229.522 -157.498)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8490",
    "data-name": "Path 8490",
    d: "M294.286,193.91a16.9,16.9,0,0,1-3.373,2.5,16.445,16.445,0,0,1-3.833,1.667,16.29,16.29,0,0,1,3.373-2.5A16.1,16.1,0,0,1,294.286,193.91Z",
    transform: "translate(-229.679 -157.888)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8491",
    "data-name": "Path 8491",
    d: "M301.059,200.3a18.332,18.332,0,0,1-4.169,7.225,16.127,16.127,0,0,1,1.677-3.833A16.589,16.589,0,0,1,301.059,200.3Z",
    transform: "translate(-230.089 -158.155)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8492",
    "data-name": "Path 8492",
    d: "M310.179,202.51a16.725,16.725,0,0,1,.479,4.168,16.291,16.291,0,0,1-.479,4.169,15.882,15.882,0,0,1-.479-4.168A16.722,16.722,0,0,1,310.179,202.51Z",
    transform: "translate(-230.623 -158.247)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8493",
    "data-name": "Path 8493",
    d: "M319.06,200a16.291,16.291,0,0,1,2.5,3.373,16.1,16.1,0,0,1,1.667,3.833,18.331,18.331,0,0,1-4.169-7.225Z",
    transform: "translate(-231.014 -158.142)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8494",
    "data-name": "Path 8494",
    d: "M325.45,193.3a16.1,16.1,0,0,1,3.833,1.667,16.292,16.292,0,0,1,3.373,2.5,16.1,16.1,0,0,1-3.833-1.667,16.292,16.292,0,0,1-3.373-2.5Z",
    transform: "translate(-231.28 -157.863)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8495",
    "data-name": "Path 8495",
    d: "M327.66,184.319a18.418,18.418,0,0,1,8.347,0A18.418,18.418,0,0,1,327.66,184.319Z",
    transform: "translate(-231.372 -157.468)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8496",
    "data-name": "Path 8496",
    d: "M325.1,175.3a16.587,16.587,0,0,1,3.373-2.492,15.754,15.754,0,0,1,3.833-1.677,18.331,18.331,0,0,1-7.225,4.169Z",
    transform: "translate(-231.265 -156.938)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8497",
    "data-name": "Path 8497",
    d: "M318.45,168.776a16.844,16.844,0,0,1,1.667-3.833,16.293,16.293,0,0,1,2.5-3.373,16.1,16.1,0,0,1-1.667,3.833A16.294,16.294,0,0,1,318.45,168.776Z",
    transform: "translate(-230.988 -156.539)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8498",
    "data-name": "Path 8498",
    d: "M561.321,422H268.731L227.18,191.27h292.6Z",
    transform: "translate(-227.18 -157.778)",
    fill: "#ff9800"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 12.161,
    cy: 12.161,
    r: 12.161,
    transform: "translate(89.235 150.219)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 12.161,
    cy: 12.161,
    r: 12.161,
    transform: "translate(185.369 150.219)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8499",
    "data-name": "Path 8499",
    d: "M399.759,339.8l-.671-1.275c-.057-.115-6.344-11.729-18.983-11.729-11.5,0-14.374,10.934-14.451,11.4l-.345,1.389-2.789-.671.335-1.4c0-.134,3.431-13.6,17.249-13.6,14.374,0,21.245,12.726,21.532,13.272l.671,1.265Z",
    transform: "translate(-232.827 -163.313)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fly--inject-38",
    transform: "translate(535.06 82.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8500",
    "data-name": "Path 8500",
    d: "M555.7,324.739l-.2-.958c.623-.134,1.236-.278,1.849-.441l.24.958C556.937,324.461,556.334,324.6,555.7,324.739Z",
    transform: "translate(-555.5 -93.781)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8501",
    "data-name": "Path 8501",
    d: "M561.432,313.829l-.307-.9c1.2-.412,2.4-.862,3.555-1.351l.374.882C563.875,312.957,562.658,313.417,561.432,313.829Zm7.139-3.057-.431-.843a37.953,37.953,0,0,0,3.306-1.917l.5.815A24.5,24.5,0,0,1,568.571,310.772Zm6.593-4.053-.565-.776c1.035-.757,2.031-1.552,2.971-2.367l.632.719c-1.006.872-1.964,1.687-3.047,2.463Zm5.845-5.1-.7-.661c.882-.958,1.715-1.917,2.482-2.875l.757.585c-.8,1.054-1.648,2.041-2.52,2.99Zm4.744-6.133-.814-.508a27.863,27.863,0,0,0,1.763-3.335l.882.393a32.328,32.328,0,0,1-1.84,3.488Zm3.172-7.11-.958-.268a25.05,25.05,0,0,0,.776-3.67l.958.125a24.584,24.584,0,0,1-.786,3.852Zm1.064-7.666h-.958v-.278c0-1.159-.067-2.338-.182-3.5l.958-.1a34.712,34.712,0,0,1,.192,3.594Zm-1.725-7.5a37.663,37.663,0,0,0-.958-3.661l.958-.287a32.061,32.061,0,0,1,.958,3.747Zm-2.271-7.216c-.46-1.131-.958-2.29-1.572-3.459l.863-.431c.584,1.188,1.121,2.377,1.591,3.526Zm-3.354-6.833c-.594-1.045-1.246-2.147-1.917-3.277l.815-.508c.7,1.14,1.361,2.252,1.917,3.316Zm-4.006-6.507c-.7-1.054-1.409-2.118-2.137-3.181l.8-.537c.728,1.064,1.437,2.127,2.137,3.2Zm-4.312-6.344c-.719-1.054-1.447-2.118-2.156-3.172l.8-.537c.709,1.054,1.428,2.118,2.146,3.162Zm-4.283-6.382c-.7-1.073-1.38-2.166-2.051-3.258l.815-.5c.671,1.092,1.351,2.166,2.041,3.239Zm-4-6.583c-.652-1.16-1.255-2.309-1.8-3.411l.862-.431c.537,1.092,1.141,2.223,1.773,3.373Zm-3.4-6.9c-.508-1.2-.958-2.415-1.38-3.6l.958-.307c.4,1.16.853,2.357,1.351,3.536Zm-2.491-7.312c-.316-1.246-.594-2.52-.8-3.833l.958-.153c.211,1.227.469,2.472.786,3.7Zm-1.284-7.666c-.1-1.179-.144-2.367-.144-3.555v-.316h.958v.307a28.071,28.071,0,0,0,.144,3.479Zm.958-7.666-.958-.1c0-.259.048-.527.077-.8.115-1.025.259-2.051.431-3.028l.958.163c-.163.958-.307,1.964-.422,2.971a1.973,1.973,0,0,1-.038.824Zm1.332-7.455-.958-.259c.355-1.265.767-2.5,1.227-3.68l.891.345a35.083,35.083,0,0,0-1.112,3.622Zm47.751-5.587a11.984,11.984,0,0,1-1.639-.153c-.747-.105-1.495-.23-2.233-.374l.192-.958c.709.134,1.447.259,2.175.364.517.067,1.045.115,1.552.144Zm3.938-.3-.2-.958a11.058,11.058,0,0,0,3.411-1.322l.5.815a11.931,11.931,0,0,1-3.661,1.495Zm-48.93-1.14-.853-.45a34,34,0,0,1,2.022-3.316l.786.546a31.334,31.334,0,0,0-1.907,3.249Zm37.373-.058a36.9,36.9,0,0,1-3.641-1.37l.393-.882a32.7,32.7,0,0,0,3.536,1.332Zm18.207-2.99-.8-.537a6.707,6.707,0,0,0,1.169-3.344l.958.067a7.667,7.667,0,0,1-1.3,3.843Zm-25.3-.144a35.146,35.146,0,0,1-3.249-2.137l.566-.767a33.816,33.816,0,0,0,3.162,2.07Zm-25.969-2.99-.709-.642a32.422,32.422,0,0,1,2.769-2.731l.632.719a32.017,32.017,0,0,0-2.664,2.683Zm19.731-1.619a35.452,35.452,0,0,1-2.712-2.789l.719-.632a35.3,35.3,0,0,0,2.635,2.712Zm31.192-2.6a9.364,9.364,0,0,0-2.233-2.875l.632-.719a10.349,10.349,0,0,1,2.463,3.153Zm-45.25-.757-.546-.786a36.945,36.945,0,0,1,3.325-2.022l.45.843a36.178,36.178,0,0,0-3.2,1.993Zm8.95-2.492c-.364-.517-.719-1.045-1.054-1.591l-1.246.489-.364-.882,1.1-.441c-.172-.287-.345-.575-.508-.862l.834-.47c.192.335.383.671.584.958q.805-.287,1.639-.546l.278.958c-.47.144-.958.3-1.4.46a11.655,11.655,0,0,0,.958,1.37Zm30.981-1.648a20.4,20.4,0,0,0-2.875-1.169l-.632-.2.278-.958.652.211a20.708,20.708,0,0,1,2.99,1.217Zm-26.046-1.715-.2-.958c1.236-.278,2.52-.508,3.833-.69l.144.958c-1.265.2-2.52.441-3.747.719Zm18.878-.517c-1.2-.211-2.463-.374-3.756-.489l.077-.958c1.332.115,2.626.278,3.833.5Zm-11.355-.556-.067-.958c1.14-.067,2.281-.105,3.411-.105h.469v.958h-.46c-1.083.029-2.214.057-3.325.134Zm-16.2-2.29c-.517-1.169-.958-2.386-1.39-3.622l.958-.3c.4,1.207.853,2.4,1.351,3.536Zm-2.424-7.36c-.287-1.236-.527-2.52-.709-3.833l.958-.134c.182,1.265.412,2.52.69,3.737Zm-1.073-7.666c-.048-.862-.077-1.744-.077-2.626V150.05h.958v1.227c0,.862,0,1.734.067,2.568Zm1.14-7.666-.958-.1c.134-1.265.316-2.559.537-3.833l.958.163a36.435,36.435,0,0,0-.565,3.785Zm1.313-7.484-.958-.23c.307-1.236.661-2.482,1.054-3.728l.958.3c-.431,1.255-.786,2.472-1.083,3.68Zm2.3-7.254-.891-.345c.47-1.2.958-2.4,1.543-3.555l.862.422a37.513,37.513,0,0,0-1.543,3.536Zm3.3-6.833-.834-.489c.652-1.1,1.351-2.2,2.079-3.258l.786.546c-.747,1.054-1.428,2.127-2.06,3.22Zm4.322-6.238-.748-.6c.805-.958,1.667-1.974,2.559-2.875l.69.661a35.236,35.236,0,0,0-2.53,2.836Zm5.213-5.52-.642-.709c.958-.853,1.917-1.7,2.942-2.511l.594.757c-1.025.815-2,1.648-2.923,2.482Zm5.951-4.734-.546-.8c1.045-.719,2.137-1.428,3.249-2.1l.489.815c-1.112.68-2.146,1.38-3.22,2.1Zm6.507-3.958-.45-.843c1.131-.6,2.3-1.179,3.469-1.715l.4.872c-1.217.546-2.338,1.121-3.45,1.706Zm6.928-3.181-.354-.9c1.207-.47,2.424-.958,3.632-1.313l.307.958c-1.217.364-2.424.8-3.613,1.275Z",
    transform: "translate(-555.634 -84.414)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8502",
    "data-name": "Path 8502",
    d: "M622.63,98.559l-.24-.958c1.188-.307,1.917-.441,1.917-.441l.172.958S623.789,98.262,622.63,98.559Z",
    transform: "translate(-558.291 -84.344)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8503",
    "data-name": "Path 8503",
    d: "M639.622,91.971c-2.444-7.57-18.811-4.849-15.62,5.05S642.066,99.551,639.622,91.971Z",
    transform: "translate(-558.341 -83.946)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8504",
    "data-name": "Path 8504",
    d: "M614.73,88.782c.125-3.325,4.744-5.884,11.279-4.705s12.678,5.587,12.678,5.587-6.449,3.91-13.052,4.628S614.605,92.1,614.73,88.782Z",
    transform: "translate(-557.971 -83.786)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8505",
    "data-name": "Path 8505",
    d: "M638.845,89.867c-3.392,0-6.775-.1-10.158-.2s-6.775-.278-10.158-.546c3.392,0,6.785.086,10.167.192S635.472,89.59,638.845,89.867Z",
    transform: "translate(-558.13 -84.008)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8506",
    "data-name": "Path 8506",
    d: "M621.58,85.91a28.51,28.51,0,0,1,5.414,3.383,25.512,25.512,0,0,1-2.8-1.533A27.424,27.424,0,0,1,621.58,85.91Z",
    transform: "translate(-558.257 -83.874)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8507",
    "data-name": "Path 8507",
    d: "M630.606,89.57A31.114,31.114,0,0,1,625,93.192a31.111,31.111,0,0,1,5.635-3.622Z",
    transform: "translate(-558.4 -84.027)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8508",
    "data-name": "Path 8508",
    d: "M631.88,87.62a6.939,6.939,0,0,1,2.472,1.993A6.562,6.562,0,0,1,633,88.76a7.012,7.012,0,0,1-1.121-1.14Z",
    transform: "translate(-558.687 -83.946)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8509",
    "data-name": "Path 8509",
    d: "M621.2,108.909c2.041,2.626,7.283,1.993,11.892-2.779s7.053-11.95,7.053-11.95-7.551.575-13.31,3.833S619.145,106.273,621.2,108.909Z",
    transform: "translate(-558.208 -84.219)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8510",
    "data-name": "Path 8510",
    d: "M640.3,94.18c-2.76,1.917-5.443,4.044-8.136,6.1s-5.328,4.188-7.906,6.382c2.76-1.917,5.443-4.034,8.126-6.095S637.685,96.384,640.3,94.18Z",
    transform: "translate(-558.369 -84.219)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8511",
    "data-name": "Path 8511",
    d: "M628.58,107.743a27.3,27.3,0,0,0,1.37-2.875,25.593,25.593,0,0,0,1.035-3.028,26.62,26.62,0,0,0-1.37,2.875A27.356,27.356,0,0,0,628.58,107.743Z",
    transform: "translate(-558.549 -84.539)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8512",
    "data-name": "Path 8512",
    d: "M633.708,99.638a31.682,31.682,0,0,0-6.708.355,27.977,27.977,0,0,0,3.354,0A29.806,29.806,0,0,0,633.708,99.638Z",
    transform: "translate(-558.483 -84.445)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8513",
    "data-name": "Path 8513",
    d: "M635.93,100.5A6.853,6.853,0,0,0,636.524,99a7.177,7.177,0,0,0,.249-1.581,7.139,7.139,0,0,0-.843,3.076Z",
    transform: "translate(-558.856 -84.354)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8514",
    "data-name": "Path 8514",
    d: "M640.156,91.916a2.875,2.875,0,1,1,1.849-3.613A2.875,2.875,0,0,1,640.156,91.916Z",
    transform: "translate(-558.875 -83.891)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8515",
    "data-name": "Path 8515",
    d: "M642,97.626A2.875,2.875,0,1,1,643.846,94,2.875,2.875,0,0,1,642,97.626Z",
    transform: "translate(-558.952 -84.129)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-38",
    transform: "translate(251.315 67.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8516",
    "data-name": "Path 8516",
    d: "M312.052,94.173a23.88,23.88,0,0,1-39.9,15.112l-11.95,1.754,5.98-10.33a23.88,23.88,0,1,1,45.873-6.535Z",
    transform: "translate(-259.433 -67.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8517",
    "data-name": "Path 8517",
    d: "M312.019,94.161a23.957,23.957,0,0,1-4.791,12.1,21.188,21.188,0,0,1-4.686,4.628,23.248,23.248,0,0,1-5.75,3.21,23.506,23.506,0,0,1-6.43,1.533,23.96,23.96,0,0,1-3.316.067,21.255,21.255,0,0,1-3.306-.345,24.11,24.11,0,0,1-11.816-5.836l.278.086-11.931,1.83-.872.134.441-.767,5.941-10.349v.412a24.13,24.13,0,0,1,1.476-21.283,24,24,0,0,1,37.679-5.194A23.957,23.957,0,0,1,312.019,94.161Zm0,0a23.621,23.621,0,0,0-27.081-25.873,23.363,23.363,0,0,0-9.861,3.891,24.618,24.618,0,0,0-7.149,7.8,23.593,23.593,0,0,0-3.038,10.1,23.832,23.832,0,0,0,1.687,10.484l.086.211-.115.2-6.018,10.311-.422-.632,11.959-1.677h.163l.115.105a23.536,23.536,0,0,0,11.442,5.855,20.344,20.344,0,0,0,3.239.393,23.249,23.249,0,0,0,3.268,0,23.957,23.957,0,0,0,6.382-1.409,22.461,22.461,0,0,0,5.75-3.1,21.83,21.83,0,0,0,4.7-4.571A23.957,23.957,0,0,0,312.019,94.161Z",
    transform: "translate(-259.4 -67.542)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8518",
    "data-name": "Path 8518",
    d: "M277.34,103.276a2.319,2.319,0,0,1,2.338-2.453,2.453,2.453,0,0,1,0,4.906,2.319,2.319,0,0,1-2.338-2.453Zm.958-5.663L277.742,78.6h3.833l-.556,19.012Z",
    transform: "translate(-260.148 -68.004)",
    fill: "#ff9800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8519",
    "data-name": "Path 8519",
    d: "M286.85,103.276a2.319,2.319,0,0,1,2.329-2.453,2.453,2.453,0,0,1,0,4.906,2.319,2.319,0,0,1-2.329-2.453Zm.958-5.663L287.281,78.6h3.833l-.556,19.012Z",
    transform: "translate(-260.545 -68.004)",
    fill: "#ff9800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8520",
    "data-name": "Path 8520",
    d: "M296.35,103.276a2.319,2.319,0,0,1,2.338-2.453,2.453,2.453,0,0,1,0,4.906,2.319,2.319,0,0,1-2.338-2.453Zm.958-5.663L296.752,78.6h3.833l-.546,19.012Z",
    transform: "translate(-260.942 -68.004)",
    fill: "#ff9800"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataCuate);
export default __webpack_public_path__ + "static/media/No data-cuate.c2738bfc62e2c7f13f1ff1adf08529e7.svg";
export { ForwardRef as ReactComponent };